





















































import { Component , Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';

const cssPrefix = 'csc2-vdo';
@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
    SwStatusInfo,
    SwCheckbox,
  },
})
export default class Csc2Vdo extends SwExtendedVue {
  cssPrefix = cssPrefix;
  vdoCheckBox : boolean = false;
  @Prop()
  showWirelessDialog: boolean;
  @Prop({ required : true })
  vdoSrc: string;
  @Prop({ required : true })
  headerMsg: string;
  created() {
    console.warn('this.dataCenter');
  }
  closeDialog() {
    if (this.vdoCheckBox) {
      this.$emit('close-dialog-withApi');
    } else {
      this.$emit('close-dialog');
    }
  }
}
